/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import {LogListItem, LogsList, LogLevel} from '../LogsList'
import {useCustomerLogsList} from './useCustomerLogsList'

export interface LogListItemPage {
  items: LogListItem[]
  taken: number
  skipped: number
}

export interface CustomerLogsClient {
  getEvents: (options: EventsPageParameters) => Promise<LogListItemPage>
}

export interface CustomerLogsListProps {
  popoverZIndex?: number
  client: CustomerLogsClient
  initialOptions?: LogSearchOptions
  serviceOptions: string[]
  levelOptions: LogLevel[]
  headerHidden?: boolean
}

export interface LogSearchOptions {
  level?: LogLevel
  service?: string
  createdAfter?: Date
  createdBefore?: Date
  search?: string
  take?: number
  skip?: number
}

export interface EventsPageParameters {
  levels?: string[]
  services?: string[]
  createdAfter?: Date
  createdBefore?: Date
  search?: string
  take?: number
  skip?: number
}

export const CustomerLogsList = ({
  client,
  initialOptions,
  levelOptions,
  serviceOptions,
  popoverZIndex,
  headerHidden
}: CustomerLogsListProps) => {
  const {
    logs,
    options,
    onLevelChange,
    onQueryChange,
    onServiceChange,
    onClearFiltersClick,
    onLoadMore,
    hasMoreData,
    onDateChange,
    hasNonEmptyFilter
  } = useCustomerLogsList(client, initialOptions)
  const {search, createdAfter, createdBefore, service, level} = options
  return (
    <LogsList
      headerHidden={headerHidden}
      popoverZIndex={popoverZIndex}
      items={logs}
      query={search}
      afterDate={createdAfter}
      beforeDate={createdBefore}
      service={service}
      level={level}
      levelOptions={levelOptions}
      servicesOptions={serviceOptions}
      onLevelChange={onLevelChange}
      onQueryChange={onQueryChange}
      onServiceChange={onServiceChange}
      onDateChange={onDateChange}
      onClearFiltersClick={onClearFiltersClick}
      onLoadMore={onLoadMore}
      hasMoreData={hasMoreData}
      hasClearButton={hasNonEmptyFilter()}
    />
  )
}
